import api from './api';

const PaymentService = {
    initiatePayment: async (planId) => {
        try {
            const response = await api.post(`/payment/initiate`, {
                planId: planId
            });

            if (response.data && response.data.paymentUrl) {
                return response.data.paymentUrl;
            }
            throw new Error('URL de paiement non reçue');
        } catch (error) {
            console.error('Erreur lors de l\'initiation du paiement:', error);
            throw error;
        }
    },

    verifyPayment: async (token) => {
        try {
            const response = await api.get(`/payment/verify`, {
                params: { token },
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la vérification du paiement:', error);
            throw error;
        }
    },

    /**
     * Initie un paiement via Chariow
     * @param {string} planId - Identifiant du plan d'abonnement
     * @returns {Object} { step, paymentUrl, purchaseId, reference }
     *   step: "payment" → rediriger vers paymentUrl
     *         "completed" → produit gratuit, accès immédiat
     *         "already_purchased" → déjà acheté
     */
    initiateChariowPayment: async (planId, paymentPhoneNumber, attribution = {}) => {
        try {
            const response = await api.post('/payment/chariow/initiate', {
                planId,
                paymentPhoneNumber,
                attribution
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'initiation du paiement Chariow:', error);
            throw error;
        }
    },

    verifyChariowPayment: async (reference) => {
        try {
            const response = await api.get(`/payment/chariow/${encodeURIComponent(reference)}`);
            return response.data;
        } catch (error) {
            console.error('Erreur lors de la vérification du paiement Chariow:', error);
            throw error;
        }
    }
};

export default PaymentService;
